import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useRetrievePlayerByUserId, useRetrieveTeamsByPlayerId, } from "./ApiProvider";
import Landing from "./Landing";
import { Welcome } from "./Welcome";
import { useRetrieveLeaguesByPlayerId } from "./api/LeagueApiProvider";
import { UserContext } from "./auth/UserProvider";
import { ErrorView } from "./nav/Error";
import { Loading } from "./nav/Loading";
import { PlayerPage } from "./players/PlayerPage";
var Home = function () {
    var _a = useContext(UserContext), contextUser = _a.user, isContextUserLoading = _a.loading;
    var _b = useRetrievePlayerByUserId({ userId: contextUser === null || contextUser === void 0 ? void 0 : contextUser.pk }), isPlayerLoading = _b.isLoading, playerError = _b.error, player = _b.data;
    var _c = useRetrieveTeamsByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), _d = _c.data, teams = _d === void 0 ? [] : _d, isTeamsLoading = _c.isLoading;
    var _e = useRetrieveLeaguesByPlayerId({ playerId: player === null || player === void 0 ? void 0 : player.id }), _f = _e.data, leagues = _f === void 0 ? [] : _f, isLeaguesLoading = _e.isLoading;
    var loading = isPlayerLoading ||
        isContextUserLoading ||
        isTeamsLoading ||
        isLeaguesLoading;
    if (!contextUser && !isContextUserLoading) {
        return _jsx(Landing, {});
    }
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!player || playerError) {
        return _jsx(ErrorView, { error: new Error("Player not found") });
    }
    var isNewUser = teams.length === 0 && leagues.length === 0;
    if (isNewUser) {
        return _jsx(Welcome, { player: player });
    }
    return _jsx(PlayerPage, { player: player, canViewTeams: true, canModify: true });
};
export default Home;
